import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, MenuItem, Stack, Step, StepConnector, stepConnectorClasses, StepLabel, Stepper, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { useFormik } from 'formik';
import AddIcon from '@mui/icons-material/Add';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../components/Header';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { addFabricator, editFabricator, getcategoryInFab, getFabricator, getFabricatorById, getInstallerInFab, getproductInFab, getsubcategoryInFab } from '../../../redux/slice/fabricator.slice';
import { Image_URL } from '../../../utils/baseURL';
import DeleteIcon from '@mui/icons-material/Delete';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage: 'linear-gradient( 95deg,#222222 0%, #FFFFFF 120%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderRadius: 1,
    },
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, icon, onClick, theme, error } = props;
    const icons = {
        1: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        2: <img src="/assets/images/icons/Customer.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
        3: <img src="/assets/images/icons/file.svg" style={{ filter: theme.palette.mode === 'light' ? 'invert(1) brightness(2)' : 'invert(0) brightness(1)' }} width="25" height="26" alt='' />,
    };

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active, error }} className={className} onClick={onClick}>
            {icons[String(icon)]}
        </ColorlibStepIconRoot>
    );
}
const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...(ownerState.active && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    }),
    ...(ownerState.completed && {
        border: theme.palette.mode === 'dark' ? '2px solid white' : '2px solid black',
    }),
    ...(ownerState.error && {
        border: '2px solid red',
    }),
}));

function AddFabricator() {
    const getuserId = localStorage.getItem("id");

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
    const assignId = state?.assignId;
    const id = state?.fabricatorId;
    const liasoningId = state?.liasoningId;
    const fabricators = useSelector(state => state.fabricator.Fabricator);
    const AllFabricator = Array.isArray(fabricators) ? fabricators.find((a) => a?.assignId == assignId) : null;
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const theme = useTheme();
    const isMobile = useMediaQuery('(max-width:500px)');

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [activeStep, setActiveStep] = React.useState(0);
    const [stepsWithErrors, setStepsWithErrors] = React.useState([false, false, false, false, false]);
    const [touchedSteps, setTouchedSteps] = React.useState([false, false, false]);
    const assignInstaller = useSelector(state => state?.fabricator?.assign)?.find((a) => a._id === assignId);
    const marketData = assignInstaller?.marketData[0];

    const validationSchemas =
        Yup.object({});

    const initialValues = {
        assignId: assignId,
        liasoningId: liasoningId,
        FabricatorDate: '',
        MultipleImages: [{
            fabricatorField: '',
            fabricatorImage: ''
        }],
        fabricatorDetails: [{
            fabricatorCatogory: '674ecfc4d2ae48d55fd31206',
            fabricatorSubCatogory: '',
            fabricatorProductName: '',
            fabricatorQty: '',
        },
        {
            fabricatorCatogory: '674ecfc4d2ae48d55fd31206',
            fabricatorSubCatogory: '',
            fabricatorProductName: '',
            fabricatorQty: '',
        }
        ],

        SystemSize: marketData?.SystemSizeKw,
        RateKw: '',
        TotalAmount: '',
    };

    const [fabricatorFields, setfabricatorFields] = React.useState(initialValues.MultipleImages || []);
    const [changeimageMultiple, setchangeimageMultiple] = React.useState([{ changed: false, index: 0 }]);


    const handleAddDetail = () => {
        setfabricatorFields([...fabricatorFields, {
            fabricatorField: '',
            fabricatorImage: ''
        }])
        setchangeimageMultiple(prev => [...prev, { changed: false, index: fabricatorFields.length }]);
        setFieldValue(`fabricatorImage.[${fabricatorFields.length}]`, '');
    }


    useEffect(() => {
        dispatch(getcategoryInFab())
        dispatch(getsubcategoryInFab())
        dispatch(getproductInFab())
        dispatch(getInstallerInFab())
    }, [dispatch])

    const isSmallScreen = useMediaQuery("(max-width:425px)");
    const steps = ['Site Photo', 'Use of Material', 'Payment'];

    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [openView, setOpenView] = React.useState(false);
    const [viewImage, setViewImage] = React.useState(null);

    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleSubmit = async (values) => {
        

        validationSchemas.validate(values, { abortEarly: false })
            .then(async () => {
                const submissionValues = {
                    ...values,
                    userId: getuserId,
                    assignId: assignId,
                    MultipleImages: values.MultipleImages.map((detail, index) => ({
                        ...detail,
                        fabricatorImage: detail.fabricatorImage instanceof File ? detail.fabricatorImage.name : detail.fabricatorImage
                    })) || null,
                    fabricatorDetails: values.fabricatorDetails.map(detail => ({
                        ...detail,
                        fabricatorCatogory: detail.fabricatorCatogory || "674ecfc4d2ae48d55fd31206",
                        fabricatorSubCatogory: detail.fabricatorSubCatogory || "",
                        fabricatorProductName: detail.fabricatorProductName || "",
                        fabricatorQty: detail.fabricatorQty || "",
                    })) || null,
                    SystemSize: marketData?.SystemSizeKw,
                    TotalAmount: (marketData?.SystemSizeKw * values.RateKw).toFixed(2) || '',
                };
                let res;

                if (values.RateKw > 0) {
                    setIsSubmitting(true);
                    if (id) {
                        res = await dispatch(editFabricator({ _id: id, ...submissionValues }));
                    } else {
                        res = await dispatch(addFabricator(submissionValues));
                    }

                    if (res.type === "fabricator/edit/fulfilled" || res.type === "fabricator/add/fulfilled") {
                        await dispatch(getInstallerInFab())
                        setActiveStep(0);
                        navigate('/admin/fabricator');
                    }
                } else {
                    alert("Rate/KW must be greater than 0")
                }


            })
            .catch((validationErrors) => {
                console.log("Form validation errors:", validationErrors);
                alert("Please fill in all required fields before submitting.");
            });
    };

    const formik = useFormik({
        initialValues: { ...initialValues, MultipleImages: fabricatorFields },
        validationSchema: validationSchemas,
        onSubmit: handleSubmit,
    });
    const { handleBlur, handleChange, resetForm, values, touched, errors, setFieldValue, setValues, validateForm, setFieldError, setFieldTouched } = formik

    React.useEffect(() => {
        if (touchedSteps.some(touched => touched)) {
            validateForm().then((formErrors) => {
                const newStepsWithErrors = [false, false, false];

                Object.keys(formErrors).forEach((errorKey) => {
                    steps.forEach((_, stepIndex) => {
                        if (errorBelongsToStep(errorKey, stepIndex)) {
                            newStepsWithErrors[stepIndex] = true;
                        }
                    });
                });

                setStepsWithErrors(newStepsWithErrors);
            });
        }
    }, [values, touchedSteps]);


    const errorBelongsToStep = (errorKey, stepIndex) => {
        if (stepIndex === 0) {
            return ['FabricatorDate', 'Fabricator'].includes(errorKey);
        }
        else if (stepIndex === 1) {
            return ['fabricatorCatogory', 'fabricatorSubCatogory', 'fabricatorProductName', 'fabricatorQty'].includes(errorKey);
        }
        else if (stepIndex === 2) {
            return ['FabricatorDate', 'Fabricator'].includes(errorKey);
        }
    };

    useEffect(() => {
        if (assignId) {
            dispatch(getFabricator());
        }
    }, [assignId, id]);

    React.useEffect(() => {
        if (id && AllFabricator) {
            dispatch(getFabricatorById(id)).then((response) => {
                if (response.payload) {
                    const FabricatorData = response.payload;
                    setValues({
                        ...FabricatorData,
                        fabricatorImage: Array.isArray(FabricatorData.fabricatorImage) ? FabricatorData.fabricatorImage[0] : FabricatorData.fabricatorImage,
                        fabricatorDetails: FabricatorData.fabricatorDetails.length > 0 ? FabricatorData.fabricatorDetails : initialValues.fabricatorDetails,
                    });
                    setfabricatorFields([...FabricatorData.MultipleImages]);
                    setfabricator([...FabricatorData.fabricatorDetails]);
                    const initialChangeImageMultiple = FabricatorData.MultipleImages.map((detail, index) => ({
                        changed: false,
                        index: index,
                    }));
                    setchangeimageMultiple(initialChangeImageMultiple);
                    const isStep1Complete = FabricatorData.MultipleImages.length > 0;
                    const isStep2Complete = FabricatorData.fabricatorDetails.some(detail =>
                        detail.fabricatorSubCatogory &&
                        detail.fabricatorProductName &&
                        detail.fabricatorQty
                    );

                    if (isStep1Complete && !isStep2Complete) {
                        setActiveStep(1);
                    } else if (isStep1Complete && isStep2Complete) {
                        setActiveStep(2);
                    } else {
                        setActiveStep(0);
                    }
                } else {
                    console.error("Unexpected response structure:", response);
                }
            }).catch(error => {
                console.error("Error fetching data:", error);
            });
        }
    }, [id, AllFabricator]);

    const handleView = (imageType) => {
        let imageUrl;
        const baseUrl = imgUrl;

        if (imageType.startsWith('MultipleImages')) {
            const match = imageType.match(/\[(\d+)\]/);
            if (match) {
                const index = parseInt(match[1], 10);
                if (values.fabricatorImage && values.fabricatorImage[index]) {
                    imageUrl = values.fabricatorImage[index] instanceof File
                        ? URL.createObjectURL(values.fabricatorImage[index])
                        : `${baseUrl}/${values.fabricatorImage[index]}`;
                } else if (values.MultipleImages && values.MultipleImages[index] && values.MultipleImages[index].fabricatorImage) {
                    imageUrl = `${baseUrl}/${values.MultipleImages[index].fabricatorImage}`;
                }
            }
        }
        if (imageUrl) {
            setViewImage(imageUrl);
            setOpenView(true);
        } else {
            console.error("No image found for the selected type:", imageType);
        }
    }
    const imgUrl = Image_URL;

    const [fabricator, setfabricator] = useState([
        { fabricatorCatogory: '674ecfc4d2ae48d55fd31206', fabricatorSubCatogory: '', fabricatorProductName: '', fabricatorQty: '' },
        { fabricatorCatogory: '674ecfc4d2ae48d55fd31206', fabricatorSubCatogory: '', fabricatorProductName: '', fabricatorQty: '' }
    ]);

    const handleAddRow = () => {
        setfabricator([...fabricator, {
            fabricatorCatogory: '',
            fabricatorSubCatogory: '',
            fabricatorProductName: '',
            fabricatorQty: '',

        }]);
    };

    const [filteredProducts, setFilteredProducts] = useState([]);
    const categories = useSelector(state => state.fabricator.category);
    const subcategories = useSelector(state => state.fabricator.subCategory);
    const productData = useSelector(state => state.fabricator.products);

    const filteredSubcategories = subcategories?.filter(subcategory =>
        subcategory.categoryData?.[0]?._id === '674ecfc4d2ae48d55fd31206'
    );

    const getFilteredProducts = (subcategoryId) => {
        return productData?.filter(product => product.subCategoryData?.[0]?._id === subcategoryId);
    };



    const handleCategoryChange = (index, value) => {
        setFieldValue(`fabricatorDetails[${index}].fabricatorCatogory`, value);
        setFieldValue(`fabricatorDetails[${index}].fabricatorSubCatogory`, "");
        setFieldValue(`fabricatorDetails[${index}].fabricatorProductName`, "");
        setFieldValue(`fabricatorDetails[${index}].fabricatorQty`, "");

        const productsForCategory = productData?.filter(product => product.mainCategory._id === value);
        setFilteredProducts(prev => {
            const newFilteredProducts = [...prev];
            newFilteredProducts[index] = productsForCategory || [];
            return newFilteredProducts;
        });
    };

    const handleSubCategoryChange = (index, value) => {
        setFieldValue(`fabricatorDetails[${index}].fabricatorSubCatogory`, value);

        const productsForSubcategory = productData?.filter(product => product.subCategory._id === value);
        setFilteredProducts(prev => {
            const newFilteredProducts = [...prev];
            newFilteredProducts[index] = productsForSubcategory || [];
            return newFilteredProducts;
        });
    };

    const handleProductChange = (index, value) => {
        setFieldValue(`fabricatorDetails[${index}].fabricatorProductName`, value);
        const product = productData?.find(product => product._id === value);
    }

    useEffect(() => {
        if (!id) {
            const initialFabricatorDetails = [
                { fabricatorCatogory: '674ecfc4d2ae48d55fd31206', fabricatorSubCatogory: '', fabricatorProductName: '', fabricatorQty: '' },
                { fabricatorCatogory: '674ecfc4d2ae48d55fd31206', fabricatorSubCatogory: '', fabricatorProductName: '', fabricatorQty: '' }
            ];
            setfabricator(initialFabricatorDetails);
            setFieldValue('fabricatorDetails', initialFabricatorDetails);
            setPersistedFabricatorDetails(initialFabricatorDetails);
        }
    }, [id]);

    const step1ValidationSchema = Yup.object({
        FabricatorDate: Yup.string().required('Date is required'),
        MultipleImages: Yup.array().of(
            Yup.object({
                fabricatorField: Yup.string().required('Field is required'),
                fabricatorImage: Yup.mixed().required('Image is required')
            })
        )
    });

    const step2ValidationSchema = Yup.object({
        fabricatorDetails: Yup.array().of(
            Yup.object({
                fabricatorSubCatogory: Yup.string().required('Subcategory is required'),
                fabricatorProductName: Yup.string().required('Product name is required'),
                fabricatorQty: Yup.string().required('Quantity is required')
            })
        )
    });

    const isStepComplete = async (stepNumber) => {
        try {
            switch (stepNumber) {
                case 0:
                    return true;
                case 1:
                    await step2ValidationSchema.validate(values, { abortEarly: false });
                    return true;
                default:
                    return true;
            }
        } catch (error) {
            return false;
        }
    };

    const [persistedFabricatorDetails, setPersistedFabricatorDetails] = useState([
        { fabricatorCatogory: '674ecfc4d2ae48d55fd31206', fabricatorSubCatogory: '', fabricatorProductName: '', fabricatorQty: '' },
        { fabricatorCatogory: '674ecfc4d2ae48d55fd31206', fabricatorSubCatogory: '', fabricatorProductName: '', fabricatorQty: '' }
    ]);

    const hasStep1Data = () => {
        return values.fabricatorDetails?.some(detail => (
            detail.fabricatorSubCatogory ||
            detail.fabricatorProductName ||
            detail.fabricatorQty
        ));
    };

    const handleNext = async () => {
        setActiveStep((prev) => prev + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = async (step) => {
        setActiveStep(step);
    };

    const handleAddFab1 = (index) => {
        const oldFabDetails = [...values.fabricatorDetails];
        const newFab = {
            fabricatorCatogory: '',
            fabricatorSubCatogory: '',
            fabricatorProductName: '',
            fabricatorQty: '',
        };

        oldFabDetails.splice(index + 1, 0, newFab);
        setfabricator(oldFabDetails);
        setFieldValue('fabricatorDetails', oldFabDetails);

        setPersistedFabricatorDetails(oldFabDetails);
    }

    const handleDeleteFab = (index) => {
        setDeleteIndex(index);
        setOpenConfirmDialog(true);
    };


    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);

    const handleConfirmDelete = (index) => {
        const updatedFabDetails = fabricator.filter((_, i) => i !== index);
        setfabricator(updatedFabDetails);
        setFieldValue('fabricatorDetails', updatedFabDetails);
    };

    return (
        <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
            {id ? (
                <Header
                    title="UPDATE FABRICATOR"
                    subtitle="Update Your Fabricator Detail"
                />
            ) : (
                <Header
                    title="ADD FABRICATOR"
                    subtitle="Manage Your Fabricator Detail"
                />
            )}
            <form onSubmit={handleSubmit} >
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>
                    {isSmallScreen ? (
                        <>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.slice(0, 3).map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={(props) => (
                                            <ColorlibStepIcon
                                                {...props}
                                                theme={theme}
                                                icon={index + 1}
                                                onClick={() => handleStep(index)}
                                                error={touchedSteps[index] && stepsWithErrors[index]}
                                                style={{
                                                    cursor: (index === 0 && hasStep1Data()) ? 'not-allowed' : 'pointer',
                                                    opacity: (index === 0 && hasStep1Data()) ? 0.5 : 1
                                                }}
                                            />
                                        )}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                            <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                                {steps.slice(3).map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel StepIconComponent={(props) => (
                                            <ColorlibStepIcon
                                                {...props}
                                                theme={theme}
                                                icon={index + 4}
                                                onClick={() => handleStep(index + 3)}
                                                error={touchedSteps[index + 3] && stepsWithErrors[index + 3]}
                                                style={{
                                                    cursor: (index === 0 && hasStep1Data()) ? 'not-allowed' : 'pointer',
                                                    opacity: (index === 0 && hasStep1Data()) ? 0.5 : 1
                                                }}
                                            />
                                        )}>
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </>
                    ) : (
                        <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                            {steps.map((label, index) => (
                                <Step key={label}>
                                    <StepLabel StepIconComponent={(props) => (
                                        <ColorlibStepIcon
                                            {...props}
                                            theme={theme}
                                            icon={index + 1}
                                            onClick={() => handleStep(index)}
                                            error={touchedSteps[index] && stepsWithErrors[index]}
                                            style={{
                                                cursor: (index === 0 && hasStep1Data()) ? 'not-allowed' : 'pointer',
                                                opacity: (index === 0 && hasStep1Data()) ? 0.5 : 1
                                            }}
                                        />
                                    )}>
                                        {label}
                                    </StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                    )}
                    {activeStep === 0 && (
                        <>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="date"
                                        label="Date:"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.FabricatorDate}
                                        name="FabricatorDate"
                                        error={!!touched.FabricatorDate && !!errors.FabricatorDate}
                                        helperText={touched.FabricatorDate && errors.FabricatorDate}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                            </Box>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(6, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                {fabricatorFields.length === 0 && handleAddDetail()}
                                {fabricatorFields && fabricatorFields.length > 0 && fabricatorFields.map((field, index) => (
                                    <React.Fragment key={index}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <TextField
                                                margin="dense"
                                                name={`MultipleImages[${index}].fabricatorField`}
                                                label={`Input Field ${index + 1} :`}
                                                type="text"
                                                fullWidth
                                                variant="filled"
                                                onChange={(e) => {
                                                    const newField = { ...fabricatorFields[index], fabricatorField: e.target.value };
                                                    const newFields = [...fabricatorFields.slice(0, index), newField, ...fabricatorFields.slice(index + 1)];
                                                    setfabricatorFields(newFields);
                                                    setFieldValue(`MultipleImages[${index}].fabricatorField`, e.target.value);
                                                }}
                                                value={values.MultipleImages?.[index]?.fabricatorField}
                                                error={touched.MultipleImages?.[index]?.fabricatorField && Boolean(errors.MultipleImages?.[index]?.fabricatorField)}
                                                helperText={touched.MultipleImages?.[index]?.fabricatorField && errors.MultipleImages?.[index]?.fabricatorField}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                            <Button variant="contained" component="label">
                                                Upload
                                                <input
                                                    type="file"
                                                    hidden
                                                    name={`MultipleImages[${index}].fabricatorImage`}
                                                    onChange={e => {
                                                        const files = Array.from(e.target.files);
                                                        setFieldValue(`fabricatorImage.[${index}]`, files[0]);
                                                        setchangeimageMultiple(prev => prev.map((item, idx) =>
                                                            idx == index ? { ...item, changed: true } : item
                                                        ));
                                                    }}
                                                    onBlur={handleBlur}
                                                />
                                            </Button>
                                            {changeimageMultiple[index]?.changed ? (
                                                values.fabricatorImage?.[index] && (
                                                    <img
                                                        src={values.fabricatorImage[index] instanceof File
                                                            ? URL.createObjectURL(values.fabricatorImage[index])
                                                            : `${imgUrl}/${values.fabricatorImage[index]}`}
                                                        alt="avatar"
                                                        width="50"
                                                        height="50"
                                                        style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                    />
                                                )
                                            ) : (
                                                values.MultipleImages?.[index]?.fabricatorImage && (
                                                    <img
                                                        src={`${imgUrl}/${values.MultipleImages[index].fabricatorImage}`}
                                                        alt="avatar"
                                                        width="50"
                                                        height="50"
                                                        style={{ objectFit: 'cover', borderRadius: '5px', marginLeft: '20px' }}
                                                    />
                                                )
                                            )}
                                            <IconButton aria-label="edit" onClick={() => handleView(`MultipleImages[${index}].fabricatorImage`)}>
                                                <RemoveRedEyeIcon />
                                            </IconButton>
                                        </div>
                                    </React.Fragment>
                                ))}
                            </Box>

                            <Box display="flex" justifyContent="flex-end" m={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<AddIcon />}
                                    onClick={handleAddDetail}
                                >
                                    Add Detail
                                </Button>
                            </Box>

                        </>
                    )}

                    {activeStep === 1 && (
                        <Box sx={{ overflowX: "auto", width: "100%" }}>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: "70px", fontSize: "14px" }} > Sr No</TableCell>
                                            <TableCell sx={{ fontSize: "14px" }} >Category</TableCell>
                                            <TableCell sx={{ fontSize: "14px" }} >Sub Category</TableCell>
                                            <TableCell sx={{ fontSize: "14px" }} >Product Name</TableCell>
                                            <TableCell sx={{ fontSize: "14px" }}>Quantity</TableCell>
                                            <TableCell sx={{ fontSize: "14px" }}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fabricator.map((person, index) => (
                                            <TableRow
                                                key={index}>
                                                <TableCell sx={{ width: 50 }}>
                                                    {index + 1}
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "200px",
                                                                sm: "220px",
                                                                md: "280px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`fabricatorDetails.${index}.fabricatorCatogory`}
                                                        onChange={e => handleCategoryChange(index, e.target.value)}
                                                        value={values.fabricatorDetails?.[index]?.fabricatorCatogory || '674ecfc4d2ae48d55fd31206'}
                                                        error={!!touched.fabricatorDetails?.[index]?.fabricatorCatogory && !!errors.fabricatorDetails?.[index]?.fabricatorCatogory}
                                                        helperText={touched.fabricatorDetails?.[index]?.fabricatorCatogory && errors.fabricatorDetails?.[index]?.fabricatorCatogory}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                        disabled
                                                    >
                                                        {categories?.map((category) => (
                                                            <MenuItem key={category._id} value={category._id} >
                                                                {category.categoryName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "200px",
                                                                sm: "220px",
                                                                md: "280px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`fabricatorDetails.${index}.fabricatorSubCatogory`}
                                                        onChange={e => setFieldValue(`fabricatorDetails.${index}.fabricatorSubCatogory`, e.target.value)}
                                                        value={values.fabricatorDetails?.[index]?.fabricatorSubCatogory || ''}
                                                        error={!!touched.fabricatorDetails?.[index]?.fabricatorSubCatogory && !!errors.fabricatorDetails?.[index]?.fabricatorSubCatogory}
                                                        helperText={touched.fabricatorDetails?.[index]?.fabricatorSubCatogory && errors.fabricatorDetails?.[index]?.fabricatorSubCatogory}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    >
                                                        {filteredSubcategories.map((subcategory) => (
                                                            <MenuItem key={subcategory._id} value={subcategory._id}>
                                                                {subcategory.subCategoryName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>

                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField
                                                        margin="dense"
                                                        select
                                                        sx={{
                                                            width: {
                                                                xs: "200px",
                                                                sm: "220px",
                                                                md: "280px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {

                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        variant="filled"
                                                        onBlur={handleBlur}
                                                        name={`fabricatorDetails.${index}.fabricatorProductName`}
                                                        onChange={e => handleProductChange(index, e.target.value)}
                                                        value={values.fabricatorDetails?.[index]?.fabricatorProductName || ''}
                                                        error={!!touched.fabricatorDetails?.[index]?.fabricatorProductName && !!errors.fabricatorDetails?.[index]?.fabricatorProductName}
                                                        helperText={touched.fabricatorDetails?.[index]?.fabricatorProductName && errors.fabricatorDetails?.[index]?.fabricatorProductName}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    >
                                                        {getFilteredProducts(values.fabricatorDetails?.[index]?.fabricatorSubCatogory)?.map(product => (
                                                            <MenuItem key={product._id} value={product._id}>
                                                                {product.productName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </TableCell>
                                                <TableCell sx={{ width: '10px' }}>
                                                    <TextField

                                                        variant="filled"
                                                        type="text"
                                                        onBlur={handleBlur}
                                                        onChange={e => setFieldValue(`fabricatorDetails[${index}].fabricatorQty`, e.target.value)}
                                                        value={values.fabricatorDetails?.[index]?.fabricatorQty || ''}
                                                        name={`fabricatorDetails.${index}.fabricatorQty`}
                                                        error={!!touched.fabricatorDetails?.[index]?.fabricatorQty && !!errors.fabricatorDetails?.[index]?.fabricatorQty}
                                                        helperText={touched.fabricatorDetails?.[index]?.fabricatorQty && errors.fabricatorDetails?.[index]?.fabricatorQty}
                                                        sx={{
                                                            width: {
                                                                xs: "80px",
                                                                sm: "80px",
                                                                md: "80px",
                                                            },
                                                            height: '40px',
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "0.8rem",
                                                                height: "40px",
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                padding: "0 12px",
                                                                height: "40px",
                                                                lineHeight: "40px",
                                                            },
                                                        }}
                                                        InputLabelProps={{
                                                            style: {
                                                                color: theme.palette.text.primary
                                                            }
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Stack spacing={2} direction="row">
                                                        <Button
                                                            variant="contained"
                                                            color="success"
                                                            onClick={() => handleAddFab1(index)}
                                                            sx={{
                                                                width: "35px",
                                                                height: "35px",
                                                                minWidth: "20px",
                                                                padding: "0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <AddIcon sx={{ fontSize: "16px" }} />
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="error"
                                                            onClick={() => handleDeleteFab(index)}
                                                            sx={{
                                                                width: "35px",
                                                                height: "35px",
                                                                minWidth: "20px",
                                                                padding: "0",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}
                                                        >
                                                            <DeleteIcon sx={{ fontSize: "16px" }} />
                                                        </Button>


                                                    </Stack>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box display="flex" justifyContent="flex-end" m={1}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<AddIcon />}
                                    onClick={handleAddRow}
                                >
                                    Add Detail
                                </Button>
                            </Box>

                        </Box>



                    )}

                    {activeStep === 2 && (
                        <>
                            <Box
                                display="grid"
                                gap="30px"
                                gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                                sx={{
                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                                }}
                            >
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="System Size:"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={marketData?.SystemSizeKw}
                                        name="SystemSize"
                                        error={!!touched.SystemSize && !!errors.SystemSize}
                                        helperText={touched.SystemSize && errors.SystemSize}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Rate/KW:"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.RateKw}
                                        name="RateKw"
                                        error={!!touched.RateKw && !!errors.RateKw}
                                        helperText={touched.RateKw && errors.RateKw}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                    <TextField
                                        fullWidth
                                        variant="filled"
                                        type="text"
                                        label="Total Amount:"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={(marketData?.SystemSizeKw * values.RateKw).toFixed(2)}
                                        name="TotalAmount"
                                        error={!!touched.TotalAmount && !!errors.TotalAmount}
                                        helperText={touched.TotalAmount && errors.TotalAmount}
                                        sx={{ gridColumn: "span 2" }}
                                        InputLabelProps={{
                                            shrink: true,
                                            style: {
                                                color: theme.palette.text.primary
                                            }
                                        }}
                                    />
                                </FormControl>
                            </Box>

                        </>
                    )}

                    <Dialog
                        fullScreen={fullScreen}
                        open={openView}
                        onClose={handleCloseView}
                        aria-labelledby="responsive-dialog-title"
                        maxWidth={"sm"}
                        fullWidth
                    >
                        <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: 'center' }}>
                            Fabricator Image
                        </DialogTitle>
                        <DialogContent style={{ backgroundColor: theme.palette.background.purple, display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                            {viewImage ? (
                                <div>
                                    <img
                                        src={viewImage}
                                        alt="Uploaded Image"
                                        style={{ width: '600px', height: 'auto', objectFit: 'contain' }}
                                    />
                                </div>
                            ) : (
                                <p>No image to display</p>
                            )}
                        </DialogContent>
                        <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                            <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openConfirmDialog}
                        onClose={() => setOpenConfirmDialog(false)}
                    >
                        <DialogTitle>Confirm Deletion</DialogTitle>
                        <DialogContent>
                            Are you sure you want to delete this item?
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenConfirmDialog(false)} sx={{ color: theme.palette.text.primary }}>
                                Cancel
                            </Button>
                            <Button
                                onClick={() => {
                                    handleConfirmDelete(deleteIndex);
                                    setOpenConfirmDialog(false);
                                }}
                                color="error"
                            >
                                Confirm Delete
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                            >
                                Back

                            </Button>
                            {activeStep < 2 && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleNext}
                                >
                                    Next
                                </Button>
                            )}
                            <Button
                                variant="contained"
                                color="primary"
                                type="button"
                                onClick={() => handleSubmit(values)}
                                disabled={isSubmitting}
                            >
                                {id ? 'Update' : 'save'}
                            </Button>
                        </Stack>
                    </FormControl>
                </Stack>
            </form>
        </Box>
    )
}

export default AddFabricator
